import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=65ea50a9"
import script from "./GroupList.vue?vue&type=script&lang=js"
export * from "./GroupList.vue?vue&type=script&lang=js"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=65ea50a9&prod&lang=less"
import style1 from "./GroupList.vue?vue&type=style&index=1&id=65ea50a9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports